<tt-page *ngIf="page">
    <tt-card class="col-xs-12 col-md-4 p-5">
        <tt-page-heading [ttModel]="shiftId === '0' ? 'h_shift_new' : 'h_shift_edit'" ttTranslate></tt-page-heading>
        <tt-input ttLabel="shift_id" [(ttModel)]="page.shift_id" [ttReadonly]="page.is_new === '0'"></tt-input>
        <tt-input ttLabel="shift_name" [(ttModel)]="page.shift_name"></tt-input>
        <tt-checkbox ttLabel="in_proposal" [(ttModel)]="page.in_proposal"></tt-checkbox>
        <tt-checkbox ttLabel="shift_allowance" [(ttModel)]="page.shift_allowance"></tt-checkbox>
        <tt-select ttLabel="text_color" [(ttModel)]="page.text_color_hex" [ttData]="colors" ttDataId="hexcolor" ttDataName="color_name"></tt-select>
        <tt-select ttLabel="background_color" [(ttModel)]="page.background_color_hex" [ttData]="colors" ttDataId="hexcolor" ttDataName="color_name"></tt-select>
        <tt-input *ngIf="page.validok > ''" ttLabel="validok_status" [ttModel]="page.validok" ttReadonly></tt-input>
    </tt-card>
    <tt-card class="col-xs-12 col-md-4 p-5">
        <tt-page-heading ttModel="h_days" ttTranslate></tt-page-heading>
        <tt-list *ngIf="page.is_new === '0'" [ttData]="weekDays" ttBadge="item_timeused"></tt-list>
    </tt-card>
    <tt-card class="col-xs-12 col-md-6 p-5">
        <tt-page-heading ttModel="h_sample" ttTranslate></tt-page-heading>
        <div class="shift-sample" [style.background-color]="page.background_color_hex" [style.color]="page.text_color_hex">SAMPLE</div>
    </tt-card>
    <tt-card class="col-xs-12 col-md-6 p-5">
        <tt-page-heading ttModel="h_functions" ttTranslate></tt-page-heading>
        <tt-button-save ttText="save" [ttLoading]="saving" (ttClick)="saveChanges()"></tt-button-save>
        <tt-button *ngIf="page.is_new === '0'" ttText="delete" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting" (ttClick)="deleteValues()"></tt-button>
    </tt-card>
</tt-page>
